import { Card, CardBody } from '@chakra-ui/react';

import { AdminIndividualsTable } from './AdminIndividualsTable';

export function AdminIndividualsList(): JSX.Element {
  return (
    <Card>
      <CardBody>
        <AdminIndividualsTable />
      </CardBody>
    </Card>
  );
}
